export const getVonageToken = async (
  accountId: number,
  params: Record<string, any>,
  callback: (data: any) => void,
) => {
  const url = `${process.env.REACT_APP_SIGNALLING_API_URL}/accounts/${accountId}/create-audio-session`;
  await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
    .then((r) => r.json())
    .then(callback);
};
